class ServerError extends Error {

    constructor(message) {
        super(message)

        message = ServerError.parseMessage(message)

        this.name = 'ServerError'
        this.message = message || 'Unknown server error'
        this.stack = (new Error()).stack
    }

    static parseMessage(message) {
        try {
            return JSON.parse(message).errors[0].error
        } catch(e) {
            return message
        }
    }
}

export default ServerError
